<template>
<v-container>
  <v-row>
    <v-col class="xs-6" cols="6">
      <v-card>
        <v-toolbar>
          <v-toolbar-title class="ml-3 mr-3">
            <TText text="LOG.list" />
            <!-- Offset, Limit and Total values of the Ultra store meta_data with the key 'logentries' -->
            <TText
              v-if="$store.state.Ultra.meta_data['logentries']"
              :text="`Limit: ${$store.state.Ultra.meta_data['logentries'].limit} | Offset: ${$store.state.Ultra.meta_data['logentries'].offset} | Total: ${$store.state.Ultra.meta_data['logentries'].total}`" 
            />
          </v-toolbar-title>
        </v-toolbar>
        <div style="width: 100%; margin-top: 16px; padding: 0 16px; display: flex; justify-content: space-between; align-items: center;">

          <!-- Pagination buttons using limit, offset and total from $store.state.Ultra.meta_data['logentries'] and ButtonOutlined component -->
          <div style="display: flex">
            <ButtonOutlined
              v-if="$store.state.Ultra.meta_data['logentries']"
              :disabled="$store.state.Ultra.meta_data['logentries'].offset === 0"
              icon="chevron-left"
              :color="$vuetify.theme.isDark ? '#fff' : '#000'"
              height="43"
              width="30"
              :style="'max-height: 43px; max-width: 30px; margin-top: 5px; margin-right: 10px;'"
              @buttonClicked="requestUObject({
                url: [
                  { projects: $route.params.project_id },
                  { logentries: '' },
                  { showWithEntitiesNormalized: '' }
                ],
                url_suffix: `&offset=${$store.state.Ultra.meta_data['logentries'].offset - $store.state.Ultra.meta_data['logentries'].limit}&limit=${$store.state.Ultra.meta_data['logentries'].limit}`,
                no_cache: true
              })"
            />
            <ButtonOutlined
              v-if="$store.state.Ultra.meta_data['logentries']"
              :disabled="$store.state.Ultra.meta_data['logentries'].offset + $store.state.Ultra.meta_data['logentries'].limit >= $store.state.Ultra.meta_data['logentries'].total"
              icon="chevron-right"
              :color="$vuetify.theme.isDark ? '#fff' : '#000'"
              height="43"
              width="30"
              :style="'max-height: 43px; max-width: 30px; margin-top: 5px; margin-right: 10px;'"
              @buttonClicked="requestUObject({
                url: [
                  { projects: $route.params.project_id },
                  { logentries: '' },
                  { showWithEntitiesNormalized: '' }
                ],
                url_suffix: `&offset=${$store.state.Ultra.meta_data['logentries'].offset + $store.state.Ultra.meta_data['logentries'].limit}&limit=${$store.state.Ultra.meta_data['logentries'].limit}`,
                no_cache: true
              })"
            />
            <!-- A Button, which loads all logentries -->
            <ButtonOutlined
              v-if="$store.state.Ultra.meta_data['logentries'] && !all_loaded"
              icon="restart"
              :loading="load_logs"
              :value="load_logs?'':'Load all'"
              :color="$vuetify.theme.isDark ? '#fff' : '#000'"
              height="43"
              width="130"
              :style="'max-height: 43px; max-width: 30px; margin-top: 5px; margin-right: 10px;'"
              @buttonClicked="load_logs = true, requestUObject({
                url: [
                  { projects: $route.params.project_id },
                  { logentries: '' },
                  { showWithEntitiesNormalized: '' }
                ],
                url_suffix: `&offset=0&limit=${$store.state.Ultra.meta_data['logentries'].total}`,
                no_cache: true
              }).then(() => load_logs = false, all_loaded = true)"
            />
            <ButtonOutlined
              v-if="$store.state.Ultra.meta_data['logentries'] && all_loaded"
              icon="restart"
              :loading="load_logs"
              :value="load_logs?'':'Show first 10'"
              :color="$vuetify.theme.isDark ? '#fff' : '#000'"
              height="43"
              width="130"
              :style="'max-height: 43px; max-width: 30px; margin-top: 5px; margin-right: 10px;'"
              @buttonClicked="load_logs = true, requestUObject({
                  url: [
                    { projects: $route.params.project_id },
                    { logentries: '' },
                    { showWithEntitiesNormalized: '' }
                  ],
                  url_suffix: '&offset=0&limit=10',
                  no_cache: true
                }).then(() => load_logs = false, all_loaded = false);"
                
            />
            <ButtonOutlined
              icon="download"
              height="43"
              width="43"
              :color="$vuetify.theme.isDark ? '#fff' : '#000'"
              :style="'max-height: 43px; max-width: 30px; margin-top: 5px; margin-right: 10px;'"
              @buttonClicked="exportLogListCSV({project_id: $route.params.project_id})"
              />
          </div>
          
          <DropDownOutlinedFlat
            label="Filter"
            :options="filter_options"
            :value="filter"
            width="200"
            background_color="color-4"
            :foreground_color="$vuetify.theme.isDark ? '#fff' : '#000'"
            @change="filter = $event"
          />
        </div>
        <v-card-text>
          <div
            v-for="(log, index) in logentries"
            :key="log.id"
            style="width: 100%"
          >
            <ClickableListItem
              :has_lines="true"
              :full_line="true"
              :is_first="index === 0"
              :is_unclickable="true"
              :margin="6"
            >
            <!-- @emittedClick="test()" -->
              <template #front>
                <TTooltip value="Copy to clipboard">
                  <TIcon :color="$vuetify.theme.isDark ? '#fff' : '#000'" style="cursor: pointer;" :name="getIconByAction(log.action)" @click.native="copyComment(log)" />
                </TTooltip>
              </template>
              <template #descriptor>
                <div class="work-package-loglist-content">
                  <TText
                    :text="`${log.user} ${getLocalDate(log.created)}`"
                    small
                    align="left"
                  />
                  <TText
                    :text="getLogText(log)"
                    :size="11"
                    :font_weight="400"
                    align="left"
                    :strikethrough="log.crossed_out"
                  />
                </div>
              </template>
              <template #info>
                <!-- <button
                  v-if="(log.action == 'comment' || log.action == 'created comment') && log.user === getUser.first_name + ' ' + getUser.last_name"
                  class="work-package-loglist-strikethrough"
                  :style="`background-color: ${log.crossed_out ? `${getTranspHexColor(workpackage_fg_hex, .25)}` : ''};`"
                  v-ripple
                  @click.prevent.stop="toggleCrossedOut(log)"
                >
                  <TIcon color="white" name="strike-through-active"/>
                </button> -->
              </template>
            </ClickableListItem>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="xs-6" cols="6">
      <v-card>
        <v-toolbar>
          <v-toolbar-title class="ml-3 mr-3"><TText text="New LOG.entry" /></v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <TextArea
            :value="new_entry"
            :label="$t('WorkpackageRework.Info.Log.Comment')"
            :placeholder="`Write your ${$t('WorkpackageRework.Info.Log.Comment')}`"
            :max_char_count="1000"
            :height="250"
            :background_color="$vuetify.theme.isDark ? '#1e1e1e' : '#fff'"
            :foreground_color="$vuetify.theme.isDark ? '#fff' : '#000'"
            @change="new_entry=$event"
            />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- color="rgba(255, 255, 255, 0.7)" -->
          <ButtonOutlined
            :loading="loading"
            class="mr-2"
            icon="floppy-disc"
            value="SAVE"
            :color="$vuetify.theme.isDark ? '#fff' : '#000'"
            @buttonClicked="loading = true, createUObject({
              url: [
                { projects: $route.params.project_id },
                { logentries: '' },
                { showWithEntitiesNormalized: '' }
              ],
              u_object: {
                comment: new_entry
              }
            }).then(() => {
              new_entry = '';
              loading = false;
            })"
          />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    TText,
    TIcon,
    ClickableListItem,
    ButtonOutlined,
    TextArea,
    DropDownOutlinedFlat,
  },
  data() {
    return {
      new_entry: '',
      loading: false,
      filter: '',
      load_logs: false,
      all_loaded: false,
    }
  },
  created(){
    this.requestUObject({
      url: [
        { projects: this.$route.params.project_id },
        { logentries: '' },
        { showWithEntitiesNormalized: '' }
      ],
      url_suffix: '&offset=0&limit=10',
      add_u_object: true
    });
  },
  computed: {
    project(){
      return this.getUObject({ type: 'projects', id: this.$route.params.project_id });
    },
    logentries(){
      let entries = this.getUObjects({ type: 'logentries', ids: this.project.logentries });
      if(this.filter) {
        entries = JSON.parse(JSON.stringify(entries.filter(entry => entry.action.includes(this.filter))));
        entries.sort((a,b) => {
          if (a.created > b.created) {
            return -1;
          }
          if (a.created < b.created) {
            return 1;
          }
          // a muss gleich b sein
          return 0;
        });
      }
      return entries;
    },
    filter_options() {
      return [
        { value: '', text: '' },
        { value: 'created', text: 'created' },
        { value: 'updated', text: 'updated' },
        { value: 'deleted', text: 'deleted' },
        { value: 'added', text: 'added' },
        { value: 'removed', text: 'removed' },
        { value: 'comment', text: 'comment' }
      ];
    },
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject'
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('View', [
      'getLocalDate'
    ]),
  },
  methods: {
    ...mapActions('Ultra', [
      'requestUObject',
      'createUObject',
    ]),
    ...mapActions('Project', [
      'exportLogListCSV',
    ]),
    copyComment(log){
      let text = log.value;
      if (!log.action.includes('comment')) {
        text = `${log.target} ${log.action}${log.value ? ': ' + log.value : ''}`;
      }
      navigator.clipboard.writeText(text);
    },
    getIconByAction(action) {
      switch (action) {
        case 'created':
          return 'sign-plus';
        case 'updated':
          return 'wrench-large';
        case 'comment':
          return 'speech-bubble';
        case 'created comment':
          return 'speech-bubble';
        case 'deleted':
          return 'bin-delete';
        case 'added':
          return 'file-add';
        case 'removed':
          return 'file-remove';
        default:
          return 'exclamation-circle';
      }
    },
    getLogText(log) {
      if(log.action != 'comment' && log.action != 'created comment') {
        // EXAMPLE: Work Package created
        // EXAMPLE: Work Package created: <Name>
        return `${log.target} ${log.action}${log.value ? ': ' + log.value : ''}`;
      }
      else {
        // NOTE: there should never be a comment without a value (without text)
        return `Comment: ${log.value}`;
      }
    },
  }
}
</script>
